export const mutations = {
  addInvoiceItems(state) {
    state.invoice_items.push({
      description: "",
      amount: ""
    });
  },

  addContainerItems(state) {
    state.container_details.push({
      container_no: "",
    });
  },

  STORE_INVOICES(state, invoices) {
    state.invoices = invoices;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/mutations.js